import { Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import FAQPage from './pages/FAQ';
import AboutContact from './pages/AboutContact';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import usePageTracking from './hooks/usePageTracking';

interface AppProps {
  defaultLanguage: string;
}

function App({ defaultLanguage }: AppProps) {
  const { i18n } = useTranslation();
  usePageTracking();

  useEffect(() => {
    i18n.changeLanguage(defaultLanguage);
  }, [defaultLanguage]);

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-background relative">
        <Header />
        <main className="flex-grow pt-16 md:pt-24 relative">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/about" element={<AboutContact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;